import React from 'react'
import { string, node } from 'prop-types'
import styled from 'styled-components'

const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 19px;
  padding-top: 10px;
  svg {
    transform: scale(1.5);
    padding-right: 11px;
    width: 28px;
    path {
      stroke: #3f49b5;
    }
  }
  p {
    margin: 0;
    font-family: "Noto Sans Display", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #343a4f;
  }
`

export const IconText = ( { Icon, text } ) => {
  return (
    <IconTextContainer>
      <div>

        <Icon />
      </div>

      <p>{text}</p>
    </IconTextContainer>
  )
}


IconText.propTypes = {
  'Icon': node.isRequired,
  'text': string.isRequired
}
